import NextLink from 'next/link';
import { type FC } from 'react';

import { Link } from '@craft/ui/components/buttons';
import { Icon } from '@craft/ui/components/icons';
import { Typography } from '@craft/ui/components/typography';

import type * as types from './types';

import { Pages } from '@/src/config/pages';

import { useIsNavButtonSelected } from './useIsNavButtonSelected';

export const DesktopSideNavButton: FC<types.ISideNavButton> = props => {
  const isSelected = useIsNavButtonSelected(props);

  const href = props.page ? Pages.constructPath(props.page, {}) : props.href;

  return (
    <Link
      aria-label={`go to ${props.children.toLowerCase()} page`}
      component={props.isExternal ? 'a' : NextLink}
      data-attr-selected={isSelected}
      href={href}
      shouldOpenInNewTab={props.isExternal}
      size='auto'
      sx={t => ({
        '&:focus': { outline: `2px solid ${t.palette.secondary.main}`, outlineOffset: '-2px' },
        backgroundColor: isSelected ? t.palette.action.selected : undefined,
        borderRadius: '0.5rem',
        color: isSelected ? t.palette.secondary.main : t.palette.text.secondary,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        margin: 0,
        minHeight: 72,
        overflow: 'hidden',
        paddingX: 0,
        paddingY: '10px',
        textAlign: 'center',
        whiteSpace: 'wrap',
      })}
    >
      <Icon icon={props.icon} />
      <Typography
        fontWeight={isSelected ? 700 : 400}
        lineClamp={2}
        maxWidth='100%'
        variant='subtitle2'
      >
        {props.children}
      </Typography>
    </Link>
  );
};
